import { render } from "./ProfileParent.vue?vue&type=template&id=a44657cc&ts=true"
import script from "./ProfileParent.vue?vue&type=script&lang=ts"
export * from "./ProfileParent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3623750061/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__